import prefix from '../prefix';

export const RATE_VALUE_CHANGED = prefix('RATE_VALUE_CHANGED');
export const RATE_DIRECTION_TOGGLED = prefix('RATE_DIRECTION_TOGGLED');
export const RATE_STATUS_TOGGLED = prefix('RATE_STATUS_TOGGLED');
export const SET_EXCHANGE_RATES = prefix('SET_EXCHANGE_RATES');
export const RATE_FIELD_DIRTY = prefix('RATE_FIELD_DIRTY');
